var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.upgrade
    ? _c(
        "w-col",
        { attrs: { center: "" } },
        [
          _c("w-fa", { staticClass: "lock", attrs: { icon: "lock" } }),
          _c("p", { staticClass: "denied" }, [
            _c("span", [_vm._v(_vm._s(_vm.$ct("upgrade-required-1")))]),
            _c("span", [_vm._v(_vm._s(_vm.$ct("upgrade-required-2")))]),
          ]),
          _c(
            "p",
            [
              _c(
                "w-button",
                {
                  attrs: {
                    to: "/account/price",
                    disabled: _vm.buttonsDisabled,
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("show-plan")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "w-col",
        { attrs: { center: "" } },
        [
          _c("w-fa", { staticClass: "lock", attrs: { icon: "lock" } }),
          _c("p", { staticClass: "denied" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$ct("access-denied", { name: _vm.moduleName })) +
                " "
            ),
          ]),
          _c(
            "p",
            [
              !_vm.shouldUpgrade
                ? _c(
                    "w-button",
                    {
                      attrs: {
                        disabled: !_vm.isModuleAvailable || _vm.buttonsDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onBuyModule()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct("buy-module", { name: _vm.moduleName })
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.shouldUpgrade
                ? _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.buttonsDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.onBuyModule()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("upgrade-now")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }